import { cloneElement, useCallback, useEffect, useState } from "react";
import { ObserverEvent } from "~/services/SimpleObservable";
import { Dialog, DialogContent, DialogOverlay } from "../Dialog";
import { dialogService, DialogType } from "./DialogService";
import { Flex } from "../Flex";

export function DialogContainer() {
  const [dialogPack, setDialogPack] = useState<DialogType[]>([]);

  const hideDialogById = useCallback(
    (id: number) => {
      setDialogPack((old) => old.filter((d) => d.id !== id));
    },
    [setDialogPack],
  );

  const onUpdate = (change?: ObserverEvent): void => {
    if (change?.type === "hide") {
      setDialogPack((old) => old.filter((p) => p.id !== change.data));
      return;
    }

    const dialog = dialogService.getDialog();

    setDialogPack((prev) => {
      const alreadyExists = prev.some((s) => s.id === dialog.id);

      if (alreadyExists) return prev;

      return [...prev, { ...dialog }];
    });
  };

  useEffect(() => {
    const unsubscribe = dialogService.subscribe(onUpdate);
    return () => unsubscribe();
  }, []);

  return (
    <Flex
      css={{
        width: "100%",
      }}
    >
      {dialogPack.map((dialog, index) => (
        <Dialog
          open
          key={dialog.id}
          css={{
            width: "fit-content",
          }}
        >
          <DialogOverlay
            css={{ zIndex: index > 0 ? "$modal" : "$overlay" }}
            onClick={() => {
              if (!dialog.config?.noClose) {
                hideDialogById(dialog.id);
              }
            }}
          />
          <DialogContent
            aria-describedby={undefined}
            css={{
              width: "fit-content",
            }}
          >
            <Flex
              justify="center"
              align="center"
              css={{
                width: "100%",
                p: "$2",
              }}
            >
              {cloneElement(dialog.component, {
                onCloseClick: () => hideDialogById(dialog.id),
              })}
            </Flex>
          </DialogContent>
        </Dialog>
      ))}
    </Flex>
  );
}
